// MAIN PRODUCT SECTION ACCORDION'S
$(document).ready(function () {
  $(".product_faq_item.active .product_faq_item_answer").show();
  $(document).on("click", ".product_faq_item_question", function () {
    let parent = $(this).closest(".product_faq_item");
    let answer = parent.find(".product_faq_item_answer");

    if (parent.hasClass("active")) {
      parent.removeClass("active");
      answer.slideUp();
    } else {
      $(".product_faq_item").removeClass("active").find(".product_faq_item_answer").slideUp();
      parent.addClass("active");
      answer.slideDown();
    }
  });
});




// IMAGE WITH FAQ'S JS
$(document).ready(function () {
  // By default first answer open karo
  let firstItem = $(".lx-image-with-faq-item").first();
  firstItem.addClass("active");
  firstItem.find(".lx-image-with-faq-answer").show(); // ya .slideDown(0)
});
$(document).on("click", ".lx-image-with-faq-question", function () {
  let parent = $(this).closest(".lx-image-with-faq-item");
  let answer = parent.find(".lx-image-with-faq-answer");

  if (parent.hasClass("active")) {
    parent.removeClass("active");
    answer.slideUp();
  } else {
    $(".lx-image-with-faq-item").removeClass("active").find(".lx-image-with-faq-answer").slideUp();
    parent.addClass("active");
    answer.slideDown();
  }
});

// Mega menu hover and mobile submenu logic moved to lx-header.js

// PRODUCT META VIDEO MODAL PLAYBACK
document.addEventListener("DOMContentLoaded", function () {
  const videoTriggers = document.querySelectorAll("[data-product-meta-video-trigger]");

  videoTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const modalId = trigger.getAttribute("data-modal-target");
      if (!modalId) return;

      window.setTimeout(function () {
        const modal = document.getElementById(modalId);
        const video = modal ? modal.querySelector("video") : null;

        if (!video) return;

        video.currentTime = 0;
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      }, 120);
    });
  });
});

// PRODUCT WELLNESS SECTION CALCULATER JS
document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll(".lx-range").forEach(function(range){
    range.addEventListener("input", function(){
      let valSpan = document.getElementById("value-" + this.id.split("range-")[1]);
      if(valSpan){
        valSpan.textContent = this.value;
      }
    });
  });
});
document.querySelectorAll("input[type=range]").forEach(function(range){
  function updateRange() {
    let percent = ((range.value - range.min) / (range.max - range.min)) * 100;
    range.style.setProperty("--percent", percent + "%");
  }
  range.addEventListener("input", updateRange);
  updateRange();
});




// MAIN PRODUCT STICKY BAR JS
document.addEventListener("DOMContentLoaded", function() {
  const stickyBar = document.getElementById("sticky-bar");
  const target = document.querySelector(".product__info-wrapper .product-form");
  const header = document.querySelector("header");
  const ringop = document.getElementById("ringop");
  const emaerketTrigger = document.getElementById("emaerket-trigger");

  if (!stickyBar || !target) return;

  function checkPosition() {
    const headerHeight = header ? header.offsetHeight : 0;
    const rect = target.getBoundingClientRect();

    if (rect.bottom <= headerHeight) {
      stickyBar.classList.add("show");
      if (window.innerWidth <= 749) {
        var barHeight = stickyBar.offsetHeight;
        if (ringop) ringop.style.bottom = (barHeight + 14) + "px";
        if (emaerketTrigger) emaerketTrigger.style.bottom = (barHeight + 14) + "px";
      }
    } else {
      stickyBar.classList.remove("show");
      if (window.innerWidth <= 749) {
        if (ringop) ringop.style.bottom = "";
        if (emaerketTrigger) emaerketTrigger.style.bottom = "";
      }
    }
  }

  window.addEventListener("scroll", checkPosition);
  window.addEventListener("resize", checkPosition);

  checkPosition();
});

// E-MÆRKET CUSTOM TRIGGER — delegates click to the real widget's shadow DOM
// Widget container is rendered (opacity 0.001) so shadow DOM has full content.
// Shadow root is forced open via monkey-patch in theme.liquid.
document.addEventListener("DOMContentLoaded", function() {
  var trigger = document.getElementById("emaerket-trigger");
  if (!trigger) return;

  trigger.addEventListener("click", function() {
    var widget = document.querySelector('#emaerket-widget-mobile-1 emaerket-shadow-widget');
    if (!widget || !widget.shadowRoot) return;
    // The clickable element: shadowRoot > div > div > div (cursor: pointer)
    var target = widget.shadowRoot.querySelector('div > div > div');
    if (target) { target.click(); return; }
    // Fallback: try all divs
    var divs = widget.shadowRoot.querySelectorAll('div');
    for (var i = divs.length - 1; i >= 0; i--) { divs[i].click(); }
  });
});





$(".collection__title_btn").click(function() {
  $(".collection__title_btn").removeClass('active');
  $(this).addClass('active');
  var btn__id = $(this).attr('collection_id');

  $('.featured__collection_item').removeClass('active');
  $(this).parents('.collection').find('.featured__collection_item[collection_id="' + btn__id + '"]').addClass('active');
});



class VariantSwatches extends HTMLElement {
  constructor() {
    super();
    this.variantImages = this.closest(".card-wrapper").querySelectorAll(".variant-image");
  }

  connectedCallback() {
    // Get all radio inputs inside this component
    const inputs = this.querySelectorAll('.swatch-input__input');

    inputs.forEach(input => {
      input.addEventListener('change', (event) => {
        this.onVariantChange(event);
      });
    });
  }

  onVariantChange(event) {
    const input = event.target;
    const variantId = input.dataset.variantId;
    const optionValueId = input.dataset.optionValueId;
    const value = input.value;

    // Remove 'active' from all
    this.variantImages.forEach((img) => {
      img.classList.remove("active");
    });

    // Try to activate matching images
    let hasMatch = false;
    this.variantImages.forEach((img) => {
      if (img.dataset.variantId === variantId) {
        img.classList.add("active");
        hasMatch = true;
      }
    });

    // If no match found, activate the first element
    if (!hasMatch && this.variantImages.length > 0) {
      this.variantImages[0].classList.add("active");
    }
  }
}

customElements.define("variant-swatches", VariantSwatches);
